module.exports = __webpack_public_path__ + "img/powerGrid-icon_6.7b8fc7ee.png";